import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Spinner } from '@telus-uds/components-web';
import Delete from '@telus-uds/palette-allium/build/web/icons/Delete';
import Download from '@telus-uds/palette-allium/build/web/icons/Download';

import Confirmation from './confirmation';
import request, { apiHost } from '../../../../utils/request';

const FilesListRow = ({ fileData, removeFileFromList, orderId }) => {
  const { filename, fileId } = fileData;
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const onDeleteFile = async () => {
    try {
      setConfirmDelete(false);
      setIsDeleting(true);
      const result = await request.delete(
        `/orders/${orderId}/delete-file/${fileId}`
      );
      if (result) {
        setIsDeleting(false);
        removeFileFromList(fileId);
      }
    } catch (error) {
      setIsDeleting(false);
      throw error;
    }
  };

  const onFileDownload = () => {
    window.open(`${apiHost}/orders/${orderId}/file/${fileId}`, '_blank');
  };

  return (
    <>
      <li
        className="list-group-item"
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        {confirmDelete && (
          <Confirmation
            setConfirmDelete={setConfirmDelete}
            onDeleteFile={onDeleteFile}
            fileName={filename}
          />
        )}
        {!confirmDelete && (
          <Spinner label="" show={isDeleting} inline>
            <div>{filename}</div>
            <div>
              <Button
                icon={Download}
                onPress={onFileDownload}
                accessibilityLabel="Download"
                variant={{ text: true }}
              />
              <span style={{ margin: '0 0.5rem' }}></span>
              <Button
                icon={Delete}
                onPress={() => setConfirmDelete(true)}
                accessibilityLabel="Delete"
                variant={{ text: true }}
              />
            </div>
          </Spinner>
        )}
      </li>
    </>
  );
};

FilesListRow.propTypes = {
  fileData: PropTypes.arrayOf(PropTypes.any).isRequired,
  removeFileFromList: PropTypes.func.isRequired,
  orderId: PropTypes.number.isRequired
};

export default FilesListRow;
